export interface FilterOption<T = string> {
  text: string;
  value: T;
}

export interface AppliedFilter {
  text: string;
  unselect: () => void;
}

export const ALL_OPTION: FilterOption = { text: 'global.all', value: null };
